/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SetPasswordDialog.vue?vue&type=template&id=3fe4d218"
import script from "./SetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./SetPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe4d218')) {
      api.createRecord('3fe4d218', component.options)
    } else {
      api.reload('3fe4d218', component.options)
    }
    module.hot.accept("./SetPasswordDialog.vue?vue&type=template&id=3fe4d218", function () {
      api.rerender('3fe4d218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/SetPasswordDialog.vue"
export default component.exports